import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight, TrendingUp } from "lucide-react";
import { PORTFOLIO_PROJECTS } from "./content";
import PortfolioDialog from "./PortfolioDialog";

export default function Portfolio() {
  const [selected, setSelected] = useState(null);

  return (
    <section
      id="portfoy"
      data-testid="portfolio-section"
      className="relative py-24 sm:py-32 bg-[var(--ab-bg-soft)]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <span className="ab-chip">Portföy</span>
            <h2 className="font-display mt-5 text-4xl sm:text-5xl lg:text-6xl font-extrabold text-[var(--ab-navy)] leading-[1.05]">
              Başarı <span className="ab-text-gradient">hikayeleri</span>.
            </h2>
            <p className="mt-5 text-lg text-slate-600">
              Birlikte çalıştığımız işletmelerin elde ettiği gerçek sonuçlar.
              Detayları görmek için kartlara tıklayın.
            </p>
          </div>
          <div className="flex items-center gap-2 text-sm font-semibold text-[var(--ab-blue)]">
            <TrendingUp className="h-4 w-4" />
            Ortalama 4 ayda 3x büyüme
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {PORTFOLIO_PROJECTS.map((p, i) => (
            <motion.button
              type="button"
              key={p.slug}
              onClick={() => setSelected(p)}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.6, delay: i * 0.07 }}
              data-testid={`portfolio-item-${i}`}
              className="group relative rounded-3xl overflow-hidden border border-slate-200 bg-white hover:border-[var(--ab-blue)]/50 hover:-translate-y-1 transition-all text-left cursor-pointer focus:outline-none focus:ring-2 focus:ring-[var(--ab-blue)] focus:ring-offset-2"
              aria-label={`${p.title} vaka çalışmasını aç`}
            >
              <div className="aspect-[16/10] overflow-hidden bg-slate-100">
                <img
                  src={p.img}
                  alt={p.title}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="p-6 sm:p-7">
                <div className="flex items-start justify-between gap-4">
                  <div>
                    <div className="text-xs font-semibold uppercase tracking-widest text-[var(--ab-blue)]">
                      {p.category}
                    </div>
                    <h3 className="font-display mt-2 text-xl sm:text-2xl font-bold text-[var(--ab-navy)]">
                      {p.title}
                    </h3>
                    <div className="text-sm text-slate-500 mt-1">
                      {p.client}
                    </div>
                  </div>
                  <ArrowUpRight className="h-5 w-5 text-slate-300 group-hover:text-[var(--ab-blue)] group-hover:rotate-12 transition-all shrink-0 mt-1" />
                </div>
                <div className="mt-5 pt-5 border-t border-slate-100 flex items-end justify-between gap-3">
                  <div className="flex items-end gap-3">
                    <div className="font-display text-4xl font-extrabold ab-text-gradient">
                      {p.metric}
                    </div>
                    <div className="text-sm text-slate-500 pb-1">
                      {p.metricLabel}
                    </div>
                  </div>
                  <span className="text-xs font-semibold text-[var(--ab-navy)] group-hover:text-[var(--ab-blue)] transition-colors">
                    Vakayı incele →
                  </span>
                </div>
              </div>
            </motion.button>
          ))}
        </div>
      </div>

      <PortfolioDialog
        project={selected}
        open={!!selected}
        onOpenChange={(o) => !o && setSelected(null)}
      />
    </section>
  );
}
